import type { FullSubEvent } from '@fastnorth/timer-api';
import type { ResultEvent } from '../../types/events';
import type useAppLocation from '../../hooks/useAppLocation.ts';

type LocationState = ReturnType<typeof useAppLocation>;

// Unified type that handles both DisplayMessage and CustomMessage from timer-api
// This should probably be hoisted at some point and replace the 2 separate types
type UnifiedDisplayMessage = {
  id: string;
  content?: string;
  displaySettings?: {
    displayOnHome?: boolean; // Make all optional to handle differences
    displayOnListing?: boolean;
    displayOnDetail?: boolean;
    displayOnFollow?: boolean;
    displayOnPosting?: boolean;
  };
};

export const getDisplayMessages = (
  event: ResultEvent | null,
  subEvent: FullSubEvent | null,
  locationState: LocationState
): UnifiedDisplayMessage[] => {
  // Prefer subEvent messages (includes race-specific + event messages)
  // Fall back to event messages (only general event messages)
  const displayMessages = (subEvent?.displayMessages ||
    event?.displayMessages ||
    []) as UnifiedDisplayMessage[];

  const { isHome, isLeaderboard, isDetails, isFollowing } = locationState;
  return displayMessages.filter((message) => {
    // Filter out messages without required properties
    if (!message.content) return false;

    const { displaySettings } = message;
    if (!displaySettings) return false;

    return (
      (isHome && displaySettings.displayOnHome === true) ||
      (isLeaderboard && displaySettings.displayOnListing === true) ||
      (isDetails && displaySettings.displayOnDetail === true) ||
      (isFollowing && displaySettings.displayOnFollow === true)
    );
  });
};
